import React from 'react'

const Error = () => {
    return (
        <div className="container-fluid">
            <div className="text-center mt-5">
                <div className="error mx-auto" data-text="404">
                    <p className="m-0">404</p>
                </div>
                <p className="text-dark mb-5 lead">Page Not Found</p>
            </div>
        </div>
    )
}

export default Error